import { normalizeProjectedStatKey } from "./selectionState";

export const TEAMS_STAT_KEY = "teams";
export const TEAM_LINEUP_FEATURE_ENABLED = false;

// Keep the implementation and its previously supported leagues dormant while
// availability only proves candidate rows, not that a complete lineup will
// survive every payout/risk quote. Re-enable only after availability includes
// quoteability so the UI cannot advertise an unusable view.
const TEAM_LINEUP_LEAGUES = new Set(["mlb", "worldcup"]);
export const TEAM_LINEUP_SPORTS = TEAM_LINEUP_FEATURE_ENABLED ? ["worldcup", "mlb"] : [];

export const TEAM_LINEUP_STAT_PREFERENCES = {
  mlb: {
    selected: ["hrr", "hits+runs+rbis", "hits_runs_rbis", "hits", "runs", "tb", "total_bases", "pitching_strikeouts", "ks", "strikeouts"],
    opponent: ["pitching_strikeouts", "ks", "strikeouts", "hrr", "hits+runs+rbis", "hits_runs_rbis", "hits", "runs", "total_bases", "tb"],
  },
  worldcup: {
    selected: ["shots", "shots_on_target", "shots_on_goal", "sot", "sog", "shots_assisted", "shot_assists", "passes_attempted", "passes_completed", "goals", "assists"],
    opponent: ["shots", "shots_on_target", "shots_on_goal", "sot", "sog", "shots_assisted", "shot_assists", "passes_attempted", "passes_completed", "goals", "assists"],
  },
};

export const normalizeTeamLineupStatToken = (value) => normalizeProjectedStatKey(String(value || ""))
  .replace(/^(projected_|promo_|demon_|goblin_)/, "")
  .replace(/\s+/g, "_")
  .replace(/-/g, "_")
  .toLowerCase();

export const isTeamsLineupSport = (sport) => (
  TEAM_LINEUP_FEATURE_ENABLED && TEAM_LINEUP_LEAGUES.has(String(sport || "").toLowerCase())
);

export const withTeamsStatOption = (stats = {}, enabled = false) => {
  if (!TEAM_LINEUP_FEATURE_ENABLED || !enabled || !stats || typeof stats !== "object") {
    return stats || {};
  }

  if (Object.prototype.hasOwnProperty.call(stats, TEAMS_STAT_KEY)) {
    return stats;
  }

  const entries = Object.entries(stats);
  const popularIndex = entries.findIndex(([key]) => normalizeTeamLineupStatToken(key) === "popular");
  const insertIndex = popularIndex >= 0 ? popularIndex + 1 : 0;

  return Object.fromEntries([
    ...entries.slice(0, insertIndex),
    [TEAMS_STAT_KEY, "Teams"],
    ...entries.slice(insertIndex),
  ]);
};

export const getTeamLineupFetchStats = (sport, stats = {}) => {
  const sportKey = String(sport || "").toLowerCase();
  const preferences = TEAM_LINEUP_STAT_PREFERENCES[sportKey] || {};
  const preferredTokens = new Set([...(preferences.selected || []), ...(preferences.opponent || [])]);
  const entries = Object.keys(stats || {})
    .filter((key) => key && key !== TEAMS_STAT_KEY)
    .map((key) => ({ key, token: normalizeTeamLineupStatToken(key) }));

  const preferred = entries.filter((entry) => preferredTokens.has(entry.token));
  const fallback = entries.filter((entry) => !preferredTokens.has(entry.token) && entry.token !== "popular");
  const popular = entries.filter((entry) => entry.token === "popular");

  return [...preferred, ...fallback, ...popular]
    .map((entry) => entry.key)
    .slice(0, 12);
};
